// useNotificationPermission.js
import { useState, useEffect } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "./helper/firebase";

const useNotificationPermission = () => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const requestPermission = async () => {
      if (!messaging) {
        return;
      }
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      }
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              "BHSu8tTiPF0_nhp8boj34TO92lmKWuKquobiof4Xf3U13ZQjq6EaHncD6mZgjiCJSF6ZyGL9YAUZujMwvPVQ3QE",
          });
          setToken(token);
          console.log("Token generated: ", token);
        } else if (permission === "denied") {
          console.warn("You denied the notification request");
        }
      } catch (err) {
        setError("Failed to get permission or token");
        console.error("Error: ", err);
      }
    };

    requestPermission();
  }, []);

  return { token, error };
};

export default useNotificationPermission;
